import { render, staticRenderFns } from "./DiscussionSignOff.vue?vue&type=template&id=5c934f46&"
import script from "./DiscussionSignOff.vue?vue&type=script&lang=js&"
export * from "./DiscussionSignOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports